import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_show_plans || store.getters.is_mobile_onboarding,
    redirect: { name: 'home' },
});